import * as actions from "./userRole.actions";
import * as types from "./userRole.actionTypes";
import { ActionType, createReducer } from "typesafe-actions";
import { UserRoleReducerType } from "./types";

export type UserRoleAction = ActionType<typeof actions>;

export const initialState: UserRoleReducerType = {
  error: null,
  listRoles: [],
  isLoading: false,
  errorMessage: '',
  redirectQueue: '',
  selectedRole: null
};

export const userRoleReducer = createReducer<
  UserRoleReducerType,
  UserRoleAction
>(initialState)

  // Retrieve role list
  .handleAction(actions.getRoleAsync.request, (state) => ({
    ...state,
    error: null,
    isLoading: true,
    errorMessage: '',
    redirectQueue: '',
  }))
  .handleAction(actions.getRoleAsync.success, (state, action) => ({
    ...state,
    error: null,
    errorMessage: '',
    isLoading: false,
    redirectQueue: '',
    listRoles: action.payload.data.items,
  }))
  .handleAction(actions.getRoleAsync.failure, (state, action) => ({
    ...state,
    isLoading: false,
    redirectQueue: '',
    error: action.payload,
    errorMessage: action.payload.message,
  }))

  // Retrieve role list
  .handleAction(actions.getDetailRoleAsync.request, (state) => ({
    ...state,
    error: null,
    isLoading: true,
    errorMessage: '',
    redirectQueue: '',
  }))
  .handleAction(actions.getDetailRoleAsync.success, (state, action) => ({
    ...state,
    error: null,
    isLoading: false,
    errorMessage: '',
    redirectQueue: '',
    selectedRole: action.payload.data,
  }))
  .handleAction(actions.getDetailRoleAsync.failure, (state, action) => ({
    ...state,
    isLoading: false,
    redirectQueue: '',
    error: action.payload,
    errorMessage: action.payload.message,
  }))

  // Request to save role
  .handleAction(actions.saveRoleAsync.request, (state) => ({
    ...state,
    error: null,
    isLoading: true,
    errorMessage: '',
    redirectQueue: '',
  }))
  .handleAction(actions.saveRoleAsync.success, (state, action) => ({
    ...state,
    error: null,
    redirectQueue: '/user-role',
    isLoading: false,
    errorMessage: '',
  }))
  .handleAction(actions.saveRoleAsync.failure, (state, action) => ({
    ...state,
    isLoading: false,
    redirectQueue: '',
    error: action.payload,
    errorMessage: action.payload.message,
  }))

  // Request to create new role
  .handleAction(actions.createRoleAsync.request, (state) => ({
    ...state,
    error: null,
    isLoading: true,
    errorMessage: '',
    redirectQueue: '',
  }))
  .handleAction(actions.createRoleAsync.success, (state, action) => ({
    ...state,
    error: null,
    isLoading: false,
    errorMessage: '',
    redirectQueue: '/user-role'
  }))
  .handleAction(actions.createRoleAsync.failure, (state, action) => ({
    ...state,
    isLoading: false,
    redirectQueue: '',
    error: action.payload,
    errorMessage: action.payload.message,
  }))

  // Request to select role from the list
  .handleAction(types.SELECT_ROLE as any, (state, action) => ({
    ...state,
    error: null,
    errorMessage: '',
    redirectQueue: '',
    selectedRole: action.payload.role,
    updatedRole: action.payload.role
  }))

  // Initialize fields to create new role
  .handleAction(types.INITIALIZE_CREATE_ROLE as any, (state, action) => ({
    ...state,
    error: null,
    errorMessage: '',
    redirectQueue: '',
    selectedRole: {
      ROLE_ID: 0,
      NAME: '',
      STATUS: 1,
      PERMISSIONS: action.payload.permissions,
      PERMISSION_DETAIL: action.payload.permissions,
    },
    updatedRole: {
      ROLE_ID: 0,
      NAME: '',
      STATUS: 1,
      PERMISSIONS: action.payload.permissions,
      PERMISSION_DETAIL: action.payload.permissions,
    }
  }))

  // Update currently active role name
  .handleAction(types.UPDATE_NAME as any, (state, action) => ({
    ...state,
    selectedRole: (() => {
      if (state.selectedRole) {
        return {
          ...state.selectedRole,
          NAME: action.payload.name
        }
      }
      return null;
    })()
  }))

  .handleAction(types.UPDATE_STATUS as any, (state, action) => ({
    ...state,
    selectedRole: (() => {
      if (state.selectedRole) {
        return {
          ...state.selectedRole,
          STATUS: action.payload.value
        }
      }
      return null;
    })()
  }))

  // Update currently active role checklist
  .handleAction(types.UPDATE_PERMISSIONS as any, (state, action) => ({
    ...state,
    selectedRole: (() => {
      if (state.selectedRole) {
        return {
          ...state.selectedRole,
          PERMISSION_DETAIL: action.payload.permissions
        }
      }
      return null;
    })()
  }));
